// components/plScenario/table/TableToolbar.jsx
import React from 'react';
import { MagnifyingGlassIcon, ArrowPathIcon } from '@heroicons/react/24/outline';
import ViewSettingsDropdown from '../../Default/ViewSettingsDropdown';

const TableToolbar = ({
  // Search
  onOpenSearch,
  // View Settings
  viewMode,
  detailLevel,
  onViewModeChange,
  hideZeroRows,
  onToggleHideZeroRows,
  hiddenCount,
  // Visibility Editing
  isVisibilityEditMode,
  showHiddenItems,
  hasUnsavedVisibilityChanges,
  isSavingVisibility,
  onStartVisibilityEditing,
  onSaveVisibilityChanges,
  onCancelVisibilityEditing,
  onToggleShowHidden,
  onManageHidden,
  // Reset
  hasAdjustments,
  adjustmentsCount,
  onResetAdjustments,
}) => {
  return (
    <div className="mb-4 flex justify-between items-center px-4 gap-4">
      {/* Left side - Search */}
      <div className="flex items-center gap-3">
        <button
          onClick={onOpenSearch}
          className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-blue-700 rounded-lg hover:bg-gray-50 transition-colors"
          title="Search accounts (Ctrl+K)"
        >
          <MagnifyingGlassIcon className="h-4 w-4" />
          Search Accounts
        </button>
      </div>

      {/* Right side - View Settings & Actions */}
      <div className="flex items-center gap-3">
        {/* View Settings Dropdown */}
        {!isVisibilityEditMode ? (
          <ViewSettingsDropdown
            viewMode={viewMode}
            detailLevel={detailLevel}
            onViewModeChange={onViewModeChange}
            hideZeroRows={hideZeroRows}
            onToggleHideZeroRows={onToggleHideZeroRows}
            hiddenCount={hiddenCount}
            isVisibilityEditMode={isVisibilityEditMode}
            showHiddenItems={showHiddenItems}
            onStartVisibilityEditing={onStartVisibilityEditing}
            onToggleShowHidden={onToggleShowHidden}
            onManageHidden={onManageHidden}
          />
        ) : (
          <>
            {/* Save Button */}
            <button
              onClick={onSaveVisibilityChanges}
              disabled={!hasUnsavedVisibilityChanges || isSavingVisibility}
              className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg border transition-colors ${
                hasUnsavedVisibilityChanges && !isSavingVisibility
                  ? 'bg-green-600 text-white border-green-700 hover:bg-green-700'
                  : 'bg-gray-300 text-gray-500 border-gray-400 cursor-not-allowed'
              }`}
            >
              {isSavingVisibility ? 'Saving...' : 'Save Visibility'}
            </button>

            {/* Cancel Button */}
            <button
              onClick={onCancelVisibilityEditing}
              disabled={isSavingVisibility}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
          </>
        )}

        {/* Reset All Button */}
        <button
          onClick={onResetAdjustments}
          disabled={!hasAdjustments}
          className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg border transition-colors ${
            hasAdjustments
              ? 'border-red-300 text-red-700 bg-red-50 hover:bg-red-100'
              : 'border-gray-200 text-gray-400 bg-gray-50 cursor-not-allowed'
          }`}
        >
          <ArrowPathIcon className="w-4 h-4" />
          Reset All
          {hasAdjustments && (
            <span className="ml-1 inline-flex items-center justify-center px-2 py-0.5 text-xs font-bold leading-none text-white bg-red-600 rounded-full">
              {adjustmentsCount}
            </span>
          )}
        </button>
      </div>
    </div>
  );
};

export default TableToolbar;